import React from 'react';
import { NavLink } from 'react-router-dom';  // Use NavLink instead of Link for active styling
import { Flex, Box, Text } from '@chakra-ui/react';
import styles from '../styles/styles';

const Header = () => {
  return (
    <Flex
      bg="rgba(0, 0, 0, 0.1)" // A slightly darker transparent background for better visibility
      color="white"
      padding="10px 20px"
      align="center"
      justify="space-between"
      position="sticky"
      top="0"
      zIndex="1000"
      boxShadow="0px 4px 12px rgba(0, 0, 0, 0.3)" // Adds a shadow for a more polished look
    >
      <Box>
        <Text style={styles.titleText}>The Lost Diamond Journey</Text> {/* Title styled as per the existing titleText */}
      </Box>

      <Flex gap="20px">
        <NavLink 
          exact 
          to="/" 
          style={styles.headerLink} 
          activeStyle={styles.activeLink} // Apply activeLink style to the current page
        >
          Home
        </NavLink>
        <NavLink 
          to="/support" 
          style={styles.headerLink} 
          activeStyle={styles.activeLink} // Apply activeLink style to the current page
        >
          Support
        </NavLink>
        <NavLink 
          to="/privacy-policy" 
          style={styles.headerLink} 
          activeStyle={styles.activeLink} // Apply activeLink style to the current page
        >
          Privacy Policy
        </NavLink>
      </Flex>
    </Flex>
  );
};

export default Header;
